import React, { useContext } from 'react'
import { PackageOptionView } from 'selectors/cart/cartSelectors'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import GeoContext from 'contexts/geoContext'
import { pluralizeToString } from 'lib/string/pluralize'
import LuxuryPlusPriceGuard from 'loyalty/components/LuxuryPlusPriceGuard'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import Group from 'components/utils/Group'
import PriceStackLoyaltyProminentPrice from 'components/Luxkit/PricePoints/Loyalty/PriceStackLoyaltyProminentPrice'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'

interface Props {
  packageUpgrade: PackageOptionView;
  hasFlightsSelected?: boolean;
}

function LePackageUpgradePrice({
  packageUpgrade,
  hasFlightsSelected,
}: Props) {
  const { isTaxExclusiveRegion } = useContext(GeoContext)

  const totalPrice = isTaxExclusiveRegion ? packageUpgrade.price : packageUpgrade.price + (packageUpgrade.package.propertyFees || 0)
  const totalPriceWithFlights = hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? totalPrice + packageUpgrade.flightPrice : totalPrice
  const totalMemberPrice = isTaxExclusiveRegion ? packageUpgrade.memberPrice : packageUpgrade.memberPrice + (packageUpgrade.package.propertyFees || 0)
  const totalMemberPriceWithFlights = hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? totalMemberPrice + packageUpgrade.flightPrice : totalMemberPrice

  return <LuxuryPlusPriceGuard
    showMemberPrice={packageUpgrade.memberPriceDifference > 0}
    fallbackPrice={
      <>
        <PriceRowPrice
          size="S"
          price={packageUpgrade.priceDifference}
          signDisplay="always"
          taxesAndFees={packageUpgrade.package.taxesAndFees}
          saleUnit=""
        />
        <PriceRowCaption>
          <FormatCurrency value={totalPriceWithFlights}/> total for {pluralizeToString('night', packageUpgrade.package.duration)}
        </PriceRowCaption>
      </>
    }
  >
    <Group direction="vertical" gap={2}>
      <PriceStackLoyaltyProminentPrice
        taxesAndFees={packageUpgrade.package.taxesAndFees}
        horizontalAlign="start"
        memberPrice={packageUpgrade.memberPriceDifference}
        memberPriceSignDisplay="always"
        saleUnit=""
        size="M"
        orientation="horizontal"
        nonMemberPrice={packageUpgrade.priceDifference}
        nonMemberPriceSignDisplay="always"
      />
      <PriceRowPriceCaption>
        <FormatCurrency value={totalMemberPriceWithFlights}/> total for {pluralizeToString('night', packageUpgrade.package.duration)}
      </PriceRowPriceCaption>
    </Group>
  </LuxuryPlusPriceGuard>
}

export default LePackageUpgradePrice
